import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const ExpensesSkeleton = () => <MultipleInputSkeleton count={11} />

export default memo(ExpensesSkeleton)
